export type SimpleUser = {
  name: string;
  userName: string | null;
  id: string;
  lassoOrganizationId: string;
  email: string;
  emailConfirmed: boolean;
  phoneNumber: string | null;
  created: string;
  active: boolean;
  isPasswordSet: boolean;
  roles: UserRole[];
  productUserLinks: string[];
  settings: unknown;
};

export enum UserRole {
  User = "User",
  Admin = "Admin",
  LassoAdmin = "LassoAdmin",
  Creditsafe = "Creditsafe",
  Risikovurdering = "Risikovurdering",
  Sales = "Sales",
  Salesleader = "Salesleader",
  SalesAllCampaignAccess = "SalesAllCampaignAccess",
}

export const userRoleLabels = {
  [UserRole.Admin]: "Administrator",
  [UserRole.LassoAdmin]: "Lasso Administrator",
  [UserRole.User]: "Bruger",
  [UserRole.Creditsafe]: "Creditsafe",
  [UserRole.Risikovurdering]: "Risikovurdering",
  [UserRole.Sales]: "Sælger",
  [UserRole.Salesleader]: "Salgsleder",
} as const;
